import React, {useState} from 'react';
import { useNavigate } from 'react-router-dom';
import { signup } from '../../api/axios.js';
import BaseLayout from '../../components/BaseLayout.js';
import Card from '../../components/Card.js';
import Title from '../../components/Title.js';
import LongInput from '../../components/LongInput.js';
import ShortButton from '../../components/ShortButton.js';
import { track } from '@vercel/analytics';

const Signup = () => {

  const navigate = useNavigate();
  
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errors, setErrors] = useState({});
  const [statusMessage, setStatusMessage] = useState('');

  const validate = () => {
    const newErrors = {};
    if (!email) newErrors.email = 'Email is required';
    if (!username) newErrors.username = 'Username is required';
    if (!password) newErrors.password = 'Password is required';
    if (password !== confirmPassword) newErrors.confirmPassword = 'Passwords do not match';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setErrors({});

    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const signUpData = {
      email,
      username,
      password,
    };

    console.log(signUpData);

    try {
      await signup(signUpData);
      track("User Signup");
      setStatusMessage("Account successfully created! Check your email for verification.")
      setTimeout(() => {
        navigate('/login');
      }, 300);
    } catch (error) {
      setErrors({miscError: error.response?.data?.message || 'Sign up failed. Please try again.'});
    }
  };

  return (
    <>
      <style>
        {`
          .form-container {
            margin: 0 auto;
            padding: 0 22%;
            display: flex;
            flex-direction: column;
            padding-top: 2%;
          }

          .card-content {
            max-height: calc(100vh - 300px);
            overflow-y: auto;
            overflow-x: hidden;
            scrollbar-width: thin;
            scrollbar-color: #6B3A8F rgba(26, 26, 26, 0.5);
            padding: 10px;
          }

          .card-content::-webkit-scrollbar {
            width: 6px;
          }

          .card-content::-webkit-scrollbar-track {
            background: rgba(26, 26, 26, 0.5);
          }

          .card-content::-webkit-scrollbar-thumb {
            background-color: #6B3A8F;
            border-radius: 3px;
            border: none;
          }

          .form-fields {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 28px;
            width: 100%;
            padding-top: 4%;
          }

          .input-gap {
            margin-bottom: 16px;
          }

          .button-gap {
            margin-bottom: 12px;
          }

          .error-message {
            color: #ff4d4f;
            margin: 8px 0;
            text-align: center;
            width: 100%;
          }

          .forgot-password {
            width: 100%;
            text-align: right;
          }

          .forgot-password-button {
            color: #E1E1E6;
            font-family: 'Poppins', sans-serif;
            font-size: 12px;
            background: none;
            border: none;
            cursor: pointer;
          }

          .forgot-password-button:hover {
            color: #9797FA;
          }

          .divider-container {
            display: flex;
            align-items: center;
            gap: 16px;
            width: 100%;
            margin: 8px 0;
          }

          .divider-line {
            height: 1px;
            flex-grow: 1;
            background: #6B3A8F;
          }

          .divider-text {
            font-family: Poppins;
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: 140%;
            padding: 0 8px;
            background: conic-gradient(from 90deg at 72.69% -757.84%, #D9BAFF 0deg, #D4E8F8 183.6083436012268deg, #DAB6E0 360deg);
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }

          .remember-password {
            width: 90%;
            text-align: right;
          }

          .remember-password-button {
            color: #E1E1E6;
            font-family: 'Poppins', sans-serif;
            font-size: 12px;
            background: none;
            border: none;
            cursor: pointer;
          }

          .remember-password-button:hover {
            color: #9797FA;
          }

          .status-message {
            width: 100%;
            color: #E1E1E6;
            text-align: center;
            font-family: 'Poppins', sans-serif;
            font-size: 12px;
            font-style: normal;
            font-weight: 300;
            line-height: 140%;
            margin-top: 16px;
          }
        `}
      </style>

      <BaseLayout>
      <div className="form-container">
          <Card>
            <div className="card-content">
              <Title text="Create a New Account"/>
              <form onSubmit={handleSubmit} className="form-fields">
                <div className="form-fields">
                  <LongInput 
                    text="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    error={errors.email}
                    type="email"
                  />
                  <LongInput 
                    text="Username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    error={errors.username}
                    type="text"
                  />
                  <LongInput 
                    text="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    error={errors.password}
                    type="password"
                  />
                  <LongInput 
                    text="Confirm Password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    error={errors.confirmPassword}
                    type="password"
                  />

                  <div className="remember-password button-gap">
                    <button className="remember-password-button" type="button" onClick={() => window.history.back()}>
                      Go back to Login?
                    </button>
                  </div>
                  
                  {statusMessage && (
                    <div className="status-message">
                      {statusMessage}
                    </div>
                  )}
                  {errors.miscError && <div className="error-message">{errors.miscError}</div>}
                  <div className="button-gap"><ShortButton text="Sign Up" type="submit" onClick={handleSubmit}/></div>
                </div>
              </form>
            </div>
          </Card>
          </div>
        </BaseLayout>
    </>
  );
};

export default Signup;